<template>
  <div class="cf-footerWrap" ref="footerWrap">
    <div class="cf-footerContainer">
      <div class="mds-dialog__actions">
        <slot name="action-button-left" />
        <div class="mds-dialog__actions-right">
          <mds-button-container right-aligned>
            <slot name="action-button-right" />
          </mds-button-container>
        </div>
      </div>
    </div>
  </div>
  <!--end of cf-footerWrap-->
</template>

<script>
import { MdsButtonContainer } from "@mds/button";
//  import { MdsButton, } from "@mds/button";
export default {
  name: "cf-footer",
  components: {
    // MdsButton,
    MdsButtonContainer,
  },
  data() {
    return {};
  },
};
</script>
